<script setup lang="ts">
  import { CriticalErrorLayout } from '@storefront/components';
  import { useTranslator } from '@othercommerce/foundation';
  import { computed, ref, type Ref, onMounted, onBeforeUnmount } from 'vue';

  defineOptions({
    layout: CriticalErrorLayout,
  });

  interface Props {
    title?: string | null;
    description?: string | null;
  }

  const props = defineProps<Props>();
  const translator = useTranslator();

  const interval = ref() as Ref<number>;
  const time = ref(60) as Ref<number>;

  const title = computed(() => {
    return props.title || translator.trans('SHOP.ERROR.HEADER.503');
  });

  const description = computed(() => {
    return props.description || translator.trans('SHOP.ERROR.MESSAGE.503');
  });

  onMounted(() => {
    interval.value = setInterval(() => {
      time.value = time.value - 1;

      if (time.value <= 0) {
        clearInterval(interval.value);
        window.location.reload();
      }
    }, 1000);
  });

  onBeforeUnmount(() => {
    clearInterval(interval.value);
  });
</script>
<template>
  <div class="service-unavailable">
    <h1>{{ title }}</h1>
    <QuillContent v-if="description" :content="description" />
    <p class="service-unavailable__timer">
      {{ $tc('SHOP.ERROR.MESSAGE.RETRY_IN', time, { time }) }}
    </p>
  </div>

  <RouterView />
</template>
<style scoped lang="scss">
  .service-unavailable {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;

    h1 {
      text-align: center;
    }

    :deep(.ql-editor) {
      max-width: 600px;
      text-align: center;
    }
  }
</style>
